import {Component, inject, input} from '@angular/core';
import {Router} from '@angular/router';
import {NgClass, SlicePipe} from '@angular/common';
import {Destination} from 'src/app/presentation/main-view/add-device/add-water-point/add-water-point.component';
import {UserStore} from 'src/app/domain/user/user.store';
import {WaterPointSvgComponent} from "src/app/presentation/common/icons/water-point-svg/water-point-svg.component";

@Component({
  selector: 'app-unassigned-water-monitor-button',
  imports: [
    NgClass,
    SlicePipe,
    WaterPointSvgComponent
],
  templateUrl: './unassigned-water-monitor-button.component.html',
  styleUrl: './unassigned-water-monitor-button.component.css'
})
export class UnassignedWaterMonitorButtonComponent {

  id = input.required<string>();

  userStore = inject(UserStore);

  private router = inject(Router);

  onClick() {
    if (!this.userStore.canEdit()) return;

    const id = this.id();
    if (!id) return;

    this.router.navigate(
      ['/main/add-water-point'],
      { queryParams: { hardwareId: id, destination: Destination.WATER_POINTS } }
    );
  }
}
